import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
import '../cpdpro.css';

export default function CpdProHomePage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <section className="cpd-hero">
        <div className="container">
          <h1 className="cpd-hero-title">{t('hero.title', 'The Smartest Way to Manage Your CPD Points')}</h1>
          <p className="cpd-hero-subtitle">
            {t(
              'hero.subtitle',
              'Earn internationally recognized CPD/PE points from anywhere in the world with our AI-powered platform.'
            )}
          </p>
          <div className="cpd-home-cta">
            <button className="btn-primary-cta" onClick={() => window.location.href = 'https://cpd-pro.app/'}>
              {t('launchPlatform', 'Launch Platform')}
            </button>
            <button className="btn-secondary-cta" onClick={() => navigate(`/login?lang=${i18n.language}`)}>
              {t('signIn', 'Sign In')}
            </button>
          </div>
        </div>
      </section>

      <section className="cpd-home-summary">
        <div className="container">
          <h2>{t('cpd.home.title', 'CPD made simple')}</h2>
          <p className="muted">
            {t(
              'cpd.home.subtitle',
              'Start here. Then use the tabs above to dive deeper into pricing, accreditation, FAQs, and why professionals choose CPD Pro.'
            )}
          </p>

          <div className="home-cards">
            <div className="home-card">
              <h3>{t('cpd.home.card1.title', 'No CPD stress')}</h3>
              <p>{t('cpd.home.card1.desc', 'One subscription = peace of mind for the entire year.')}</p>
              <Link className="home-link" to="/cpd-pro/abonnementen">{t('cpd.home.card1.cta', 'View subscriptions →')}</Link>
            </div>
            <div className="home-card">
              <h3>{t('cpd.home.card2.title', 'Accredited certificates')}</h3>
              <p>{t('cpd.home.card2.desc', 'Verifiable certificate IDs and audit-ready reporting.')}</p>
              <Link className="home-link" to="/cpd-pro/accreditatie">{t('cpd.home.card2.cta', 'Accreditation →')}</Link>
            </div>
            <div className="home-card">
              <h3>{t('cpd.home.card3.title', 'Fast learning')}</h3>
              <p>{t('cpd.home.card3.desc', 'Read, take a short test, and download your certificate instantly.')}</p>
              <Link className="home-link" to="/cpd-pro/waarom-cpd-pro">{t('cpd.home.card3.cta', 'Why CPD Pro →')}</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}


